import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

import Box from '@quintoandar/cozy-core/Box';
import Divider from '@quintoandar/cozy-core/Divider';
import Typography from '@quintoandar/cozy-core/Typography';

import { isToday } from 'utils/isToday';
import { firstLetterToUpperCase } from 'utils/string';

import messages from './messages';

const ClickableBox = styled(Box)`
  cursor: pointer;
`;

const formatDate = (intl, date) => {
  const dateFormat = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };

  if (isToday({ date })) {
    return (
      <FormattedMessage
        {...messages.date}
        values={{
          day: intl.formatMessage(messages.today),
          date: intl.formatDate(date, dateFormat),
        }}
      />
    );
  }

  return firstLetterToUpperCase(
    intl.formatDate(date, { ...dateFormat, weekday: 'long' }),
  );
};

export const TimelineDay = ({ intl, date, items }) => {
  const formattedDate = formatDate(intl, date);

  return (
    <>
      <>
        <Box mb={2}>
          <Typography kind={isToday({ date }) ? 'default' : 'lighter'}>
            {formattedDate}
          </Typography>
        </Box>

        {items.map((item, index) => {
          const text = item.label || (
            <FormattedDate value={item.date} hour="2-digit" minute="2-digit" />
          );

          const isLastItem = items.length - 1 === index;

          return (
            <Box
              key={item.date.toJSON()}
              display="flex"
              mb={isLastItem ? 0 : 2}
              data-testid="timeline-day"
            >
              <Box mr={2} width={40}>
                <Typography kind="lighter">{text}</Typography>
              </Box>

              <ClickableBox flexGrow={1}>
                {item.ContentComponent}
              </ClickableBox>
            </Box>
          );
        })}
      </>

      <Box my={4}>
        <Divider />
      </Box>
    </>
  );
};

TimelineDay.propTypes = {
  date: PropTypes.instanceOf(Date),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.instanceOf(Date),
      timeDependent: PropTypes.bool,
      label: PropTypes.string,
      ContentComponent: PropTypes.node,
    }),
  ).isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(TimelineDay);
